import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  INQUIRY_STATUS,
  SWAL_SETTINGS,
  THEME_COLORS,
  showFilterlistByUser,
  showFilterlistForActivationAndDeactivation,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,

  formateDateWithMonth,

  handleServerValidations,

  removeSpecialCharacter,

  TrimText,
  writeMyExcel,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { List, ChangeStatus, Delete, ChangeVerification, ChangeActivationStatus, RejectVerificationRequest, ChangeLicenseVerification, RejectLicenseVerificationRequest, ChangeMassageLicenseVerification, ChangeInjectionLicenseVerification, ChangeProfileLicenseVerification } from "../../services/babeAssociate.service"
import { Tooltip, Whisper, Placeholder } from "rsuite";
import { AssociateReportList } from "../../services/reports.sevices";
import { usePermission } from '../../../../utils/commonfunction';

const BabeAssociateTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Babe Associates"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false)
  const [downloadReport, setDownloadReport] = useState(false);
  const statusBadgeMap = {
    PENDING: "badge-warning-light",   // 🟡 yellow
    VERIFIED: "badge-success-light",  // 🟢 green
    REJECTED: "badge-danger-light"    // 🔴 red
  };

  const statusNewBadgeMap = {
    PENDING: "badge-danger-light",   // 🟡 yellow
    VERIFIED: "badge-success-light",  // 🟢 green
    REJECTED: "badge-danger-light"    // 🔴 red
  };








  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
    statusUpdated
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/babe-associate/view/${row._id}`
    );
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  // search or activation and inactivation function
  const prepareSearchBaseOnActiveAndInactive = (key, value) => {
    let sr = { ...search };
    if (value != null && value !== "") {
      sr['isAssociateDeactivated'] = Boolean(value);
    } else {
      delete sr['isAssociateDeactivated'];
    }
    setSearch(sr);
  };


  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/babe-associate/edit/${row._id}`
    );
  };

  const changeStatusToggle = (row) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: row.status === 1 ? t("user_block_text") : t("user_unblock_text"),
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: row.status === 1 ? t("btn_block") : t("btn_unblock"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {

      if (result.isConfirmed) {
        setStatusUpdated(!statusUpdated)
        ChangeStatus({ _id: row._id, status: row.status === 1 ? 0 : 1 })
          .then((response) => {

            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {

            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };

  const changeActivationToggle = (row) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: row.isAssociateDeactivated ? t("user_InActive_text") : t("user_Active_text"),
      // imageUrl: trash,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: row.isAssociateDeactivated ? t("btn_inactive") : t("btn_active"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {

      if (result.isConfirmed) {
        setStatusUpdated(!statusUpdated)
        ChangeActivationStatus({ _id: row._id, status: row.isAssociateDeactivated })
          .then((response) => {

            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };



  const Deletefunction = (row) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        Delete({ _id: row._id }).then(response => {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })
            setStatusUpdate(!statsupdate)

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }


  const changeVerificationStatus = (_id, status) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: status ? t("label_mark_verified") : t("label_mark_unverified"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status ? t("label_verified") : t("label_unverified"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {


        ChangeVerification({ _id: _id, associate_verified: status }).then(response => {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })
            setStatusUpdate(!statsupdate)

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }

  const rejectAndNotify = (userID) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: "This action will reject the verification request and send a notification to the user",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: "Yes, Reject it",
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        RejectVerificationRequest({ _id: userID }).then(response => {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })
            setStatusUpdate(!statsupdate)

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }

  // const changeLicenseStatus = (_id, status) => {
  //   Swal.fire({
  //     customClass: 'swal-wide',
  //     title: t("msg_are_you_sure"),
  //     text: status ? t("label_license_mark_verified") : t("label_license_mark_unverified"),
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
  //     cancelButtonColor: "#000",
  //     confirmButtonText: status ? t("label_verified") : t("label_unverified"),
  //     cancelButtonText: t("btn_cancel")
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       ChangeLicenseVerification({ _id: _id, associate_profile_verification: status }).then(response => {
  //         if (response.success) {
  //           Swal.fire({
  //             icon: 'success',
  //             text: response.message,
  //             ...SWAL_SETTINGS
  //           })
  //           setStatusUpdate(!statsupdate)
  //         } else {
  //           Swal.fire({
  //             icon: 'error',
  //             text: handleServerValidations(response),
  //             ...SWAL_SETTINGS
  //           })
  //         }
  //       }).catch((error) => {
  //         console.log("deleteError", error)
  //       });
  //     }
  //   })
  // }

  // const rejectAndNotifyLicenseStatus = (userID) => {
  //   Swal.fire({
  //     customClass: 'swal-wide',
  //     title: t("msg_are_you_sure"),
  //     text: "This action will reject the request and send a notification to the user",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
  //     cancelButtonColor: "#000",
  //     confirmButtonText: "Yes, Reject it",
  //     cancelButtonText: t("btn_cancel")
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       RejectLicenseVerificationRequest({ _id: userID }).then(response => {
  //         if (response.success) {
  //           Swal.fire({
  //             icon: 'success',
  //             text: response.message,
  //             ...SWAL_SETTINGS
  //           })
  //           setStatusUpdate(!statsupdate)

  //         } else {
  //           Swal.fire({
  //             icon: 'error',
  //             text: handleServerValidations(response),
  //             ...SWAL_SETTINGS
  //           })
  //         }
  //       }).catch((error) => {
  //         console.log("deleteError", error)
  //       });
  //     }
  //   })
  // }

  const handleExportToExcel = () => {
    setDownloadReport(true);
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", datalength);
    formData.append("sort", JSON.stringify(sorting));
    formData.append("search", JSON.stringify(search));
    formData.append("global_search", globalsearch);
    AssociateReportList(formData)
      .then((data) => {
        setDownloadReport(false);
        const headers = [
          t("Name"),
          t("Email"),
          t("Phone Number"),
          t("Registration Date"),
          t("Gender"),
          t("Associate Address"),
          t("Associate Bio"),
          t("Associate Experience"),
          t("Date of Birth"),
          t("Preferred Services"),

          t("Status"),
          t("Registration Status"),
          t("User Deactivated"),
          t("Associate Verified"),
          t("Training Video Completion (%)"),
          t("Associate Status"),
          t("Associate License Number"),
          t("Associate License Expiry Date"),
          t("Associate Serving Distance (in miles)"),
          t("Associate Deactivated"),
          t("Background Check Status"),
          t("Background Check Result"),
          t("Deleted"),
          t("Created At"),
        ];

        const boolToText = (val) =>
          val === true ? "Yes" : val === false ? "No" : "N/A";

        const statusToText = (val) =>
          val === 1 ? "Active" : val === 0 ? "Inactive" : "N/A";

        const rows = data.data.list.map((row) => {
          let services = "N/A";
          if (Array.isArray(row?.associate_preferred_services)) {
            services = row.associate_preferred_services
              .map((service) => {
                const subcats = (service.subcategorydata || [])
                  .map((sub) => sub.title)
                  .join(", ");
                return subcats
                  ? `${service.title} (${subcats})`
                  : service.title;
              })
              .join(", ");
          }

          let experience = "N/A";
          if (
            row?.associate_experience !== undefined &&
            row?.associate_experience !== null
          ) {
            const expNum = Number(row.associate_experience);
            if (!isNaN(expNum)) {
              experience = expNum === 1 ? `${expNum} year` : `${expNum} years`;
            }
          }


          return [
            row?.name ?? "N/A",
            row?.email ?? "N/A",
            row?.phone_number ?? "N/A",
            row?.registration_date
              ? new Date(row.registration_date).toLocaleDateString()
              : "N/A",
            row?.gender ? capitalizeFirstLetter(row.gender) : "N/A",
            row?.associate_address?.address ?? "N/A",
            row?.associate_bio ?? "N/A",
            experience,
            row?.date_of_birth
              ? new Date(row.date_of_birth).toLocaleDateString()
              : "N/A",
            services,

            statusToText(row?.status),
            boolToText(row?.registration_status),
            boolToText(row?.isUserDeactivated),
            boolToText(row?.associate_verified),
            row?.associate_training_video_completion ?? "N/A",
            statusToText(row?.associate_status),
            row?.associate_license_number ?? "N/A",
            row?.associate_license_expiry_date
              ? new Date(row.associate_license_expiry_date).toLocaleDateString()
              : "N/A",
            row?.associate_serving_distance ?? "N/A",
            boolToText(row?.isAssociateDeactivated),
            row?.backgroundCheckStatus ?? "N/A",
            row?.backgroundCheckResult ?? "N/A",
            boolToText(row?.is_deleted),
            row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString()
              : "N/A",
          ];
        });
        writeMyExcel([headers, ...rows], `${t('Associate list')}.xlsx`);
      })
      .catch((error) => {
        setDownloadReport(false);
        console.log("error ====> ", error);
      });

  };



  const formatDateWithTime = (createdAt) => {
    const date = new Date(createdAt);
    const formattedDate = date.toLocaleDateString();

    const formattedTime = date.toLocaleTimeString().substring(0, 5);

    return `${formattedDate} ${formattedTime}`;
  }

  const changeMasssageLicenseStatus = (_id, status) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: status ? t("label_license_mark_verified") : t("label_license_mark_unverified"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status ? t("label_verified") : t("label_unverified"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeMassageLicenseVerification({ _id: _id, associate_massage_license_verification: status }).then(response => {
          if (response.success) {
            Swal.fire({ icon: 'success', text: response.message, ...SWAL_SETTINGS })
            setStatusUpdate(!statsupdate)
          } else {
            Swal.fire({ icon: 'error', text: handleServerValidations(response), ...SWAL_SETTINGS })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }


  const changeInjectionLicenseStatus = (_id, status) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: status ? t("label_license_mark_verified") : t("label_license_mark_unverified"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status ? t("label_verified") : t("label_unverified"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeInjectionLicenseVerification({ _id: _id, associate_injection_license_verification: status }).then(response => {
          if (response.success) {
            Swal.fire({ icon: 'success', text: response.message, ...SWAL_SETTINGS })
            setStatusUpdate(!statsupdate)
          } else {
            Swal.fire({ icon: 'error', text: handleServerValidations(response), ...SWAL_SETTINGS })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }

  const changeLicenseStatus = (_id, status) => {
    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: status ? t("label_license_mark_verified") : t("label_license_mark_unverified"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status ? t("label_verified") : t("label_unverified"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeProfileLicenseVerification({ _id: _id, associate_profile_verification_stauts: status }).then(response => {
          if (response.success) {
            Swal.fire({ icon: 'success', text: response.message, ...SWAL_SETTINGS })
            setStatusUpdate(!statsupdate)
          } else {
            Swal.fire({ icon: 'error', text: handleServerValidations(response), ...SWAL_SETTINGS })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Babe Associates
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div> */}
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlistByUser}
                    prepareSearch={prepareSearch}
                  />
                </div>

                <div className="me-3">
                  <StatusFilter
                    data={showFilterlistForActivationAndDeactivation}
                    prepareSearch={prepareSearchBaseOnActiveAndInactive}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn "
                >
                  {t("btn_reset_filter")}
                </button>
                <button
                  type="button"
                  onClick={() => { handleExportToExcel() }}
                  className="btn ripple btn-main-primary signbtn ms-2"
                  disabled={downloadReport}
                >
                  {t("btn_export_report")}
                </button>

              </div>
            </div>
            {
              loader ?
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                :
                <>
                  <div className="table-responsive min-h-400">
                    <table className="table table-bordered card-table border-top text-nowrap w-100">
                      <thead>
                        <tr>
                          <th className="position-relative select_head">
                            <span>{t("list_heading_sno")}</span>
                          </th>


                          <th>
                            <div className="sorting_column">
                              <span>{t("label_name")}</span>
                              <Sorting
                                sort={sorting}
                                handleSort={handleSort}
                                column="name"
                              />
                            </div>
                          </th>

                          <th>{t("label_email")}</th>
                          {/* <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_address")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="location"
                            />
                          </div>
                        </th> */}

                          <th className="">{t("label_phone_number")}</th>
                          <th className="status_head">{t("list_heading_account_blocked")}</th>
                          {/* <th className="status_head">{t("list_heading_activation_status")}</th> */}
                          <th className="status_head">{t('label_checker_status')}</th>
                          <th className="status_head">Admin Verification</th>
                          <th className="status_head">Massage License Verification</th>
                          <th className="status_head">RN License Verification</th>
                          {/* <th className="status_head">{t('label_pending_cases')}</th> */}
                          <th className="status_head">Massage Service</th>
                          <th className="status_head">{t('label_has_injection_service')}</th>
                          <th className="created_head">
                            <div className="sorting_column">
                              <span>{t("list_heading_created_date")}</span>
                            </div>
                          </th>
                          {(can("/admin/babe-associate/view") || can("/admin/babe-associate/edit") || can("/admin/babe-associate/delete")) && (
                            <th className="action_head">{t("list_heading_action")}</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {list.length ? (
                            list.map((row, i) => {
                              return (
                                <tr key={i}>
                                  <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                                  <td>{row?.name ? <div className="d-flex">{row?.name ? TrimText(capitalizeFirstLetter(row?.name), 20) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                  <td>{row?.email ? row.email : "N/A"}</td>
                                  {/* <td>{row?.associate_address && row?.associate_address?.address ? TrimText(capitalizeFirstLetter(row?.associate_address.address, 30)) : "N/A"} </td> */}
                                  <td>{row?.phone_number ? row.phone_number : "N/A"}</td>

                                  <td>
                                    <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                      <label className={"custom-switch cp" + (row.status !== 1 ? " e_none" : "")}>
                                        <input className="custom-switch-input cp" type="checkbox" checked={row?.status === 1} onChange={(e) => changeStatusToggle(row)} />
                                        <span className="custom-switch-indicator cp"></span>
                                      </label>
                                    </div>
                                  </td>

                                  {/* <td>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                      <label className={"custom-switch cp" + (row.isAssociateDeactivated !== true ? " e_none" : "")}>
                                        <input className="custom-switch-input cp" type="checkbox" checked={row?.isAssociateDeactivated === true} onChange={(e) => changeActivationToggle(row)} />
                                        <span className="custom-switch-indicator cp"></span>
                                      </label>
                                    </div>
                                  </td> */}
                                  <td>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                      <div className="mlAction">
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("label_change_checker_status")}</Tooltip>}>
                                          <span className="dropdown-toggle no-after" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i
                                              className="ri-settings-5-fill me-1"
                                              style={{
                                                color: "#000000",
                                                fontSize: "18px",
                                                cursor: "pointer",
                                                marginLeft: "6px",
                                              }}
                                            ></i>
                                          </span>
                                        </Whisper>
                                        <ul className="dropdown-menu">
                                          {!row.associate_verified && (
                                            <>
                                              <li>
                                                <button
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    changeVerificationStatus(row._id, true);
                                                  }}
                                                >
                                                  {t("btn_verified")}
                                                </button>
                                              </li>
                                              <li>
                                                <button
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    rejectAndNotify(row._id);
                                                  }}
                                                >
                                                  Reject & Notify
                                                </button>
                                              </li>
                                            </>
                                          )}

                                          {row.associate_verified && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                  changeVerificationStatus(row._id, false);
                                                }}
                                              >
                                                {t("btn_unverified")}
                                              </button>
                                            </li>
                                          )}
                                        </ul>
                                      </div>
                                      <span className={`badge badge-pill ${statusBadgeMap[row?.associate_verification_status] || "badge-secondary"}`}>{t(row?.associate_verification_status)}</span>
                                    </div>
                                  </td>

                                  {/* <td>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                      <div className="mlAction">
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("label_change_license_status")}</Tooltip>}>
                                          <span className="dropdown-toggle no-after" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i
                                              className="ri-settings-5-fill me-1"
                                              style={{
                                                color: "#000000",
                                                fontSize: "18px",
                                                cursor: "pointer",
                                                marginLeft: "6px",
                                              }}
                                            ></i>
                                          </span>
                                        </Whisper>
                                        <ul className="dropdown-menu">
                                          {!row.associate_profile_verification && (
                                            <>
                                              <li>
                                                <button
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    changeLicenseStatus(row._id, true);
                                                  }}
                                                >
                                                  {t("btn_verified")}
                                                </button>
                                              </li>
                                              <li>
                                                <button
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    rejectAndNotifyLicenseStatus(row._id);
                                                  }}
                                                >
                                                  Reject & Notify
                                                </button>
                                              </li>
                                            </>
                                          )}

                                          {row.associate_profile_verification && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                  changeLicenseStatus(row._id, false);
                                                }}
                                              >
                                                {t("btn_unverified")}
                                              </button>
                                            </li>
                                          )}
                                        </ul>
                                      </div>
                                      <span className={`badge badge-pill ${statusBadgeMap[row?.associate_license_status] || "badge-secondary"}`}>{t(row?.associate_license_status)}</span>
                                    </div>
                                  </td> */}


                                  <td>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                      <Whisper placement="top" trigger="hover" speaker={<Tooltip>Manual</Tooltip>}>
                                        <i className="ri-user-fill me-1" style={{ color: "#d4adf5", fontSize: "18px", cursor: "pointer", marginLeft: "6px" }} onClick={() => changeLicenseStatus(row._id, !row.associate_profile_verification)}></i>
                                      </Whisper>
                                      <button
                                        className={`badge badge-pill ${row?.associate_profile_verification ? "badge-success-light" : "badge-danger-light"}`}
                                        style={{ border: "none", cursor: "pointer" }}
                                        onClick={() => changeLicenseStatus(row._id, !row.associate_profile_verification)}
                                      >
                                        {row?.associate_profile_verification ? t('VERIFIED') : t('NOT VERIFIED')}
                                      </button>
                                    </div>
                                  </td>

                                  <td>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                      <Whisper placement="top" trigger="hover" speaker={<Tooltip>Manual</Tooltip>}>
                                        <i className="ri-user-fill me-1" style={{ color: "#d4adf5", fontSize: "18px", cursor: "pointer", marginLeft: "6px" }} onClick={() => changeMasssageLicenseStatus(row._id, row.associate_massage_license_status !== 'VERIFIED')}></i>
                                      </Whisper>
                                      <button
                                        className={`badge badge-pill ${statusNewBadgeMap[row?.associate_massage_license_status] || "badge-danger-light"}`}
                                        style={{ border: "none", cursor: "pointer" }}
                                        onClick={() => changeMasssageLicenseStatus(row._id, row.associate_massage_license_status !== 'VERIFIED')}
                                      >
                                        {row?.associate_massage_license_status === 'VERIFIED' ? t('VERIFIED') : t('NOT VERIFIED')}
                                      </button>
                                    </div>
                                  </td>

                                  <td>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                      <Whisper placement="top" trigger="hover" speaker={<Tooltip>Manual</Tooltip>}>
                                        <i className="ri-user-fill me-1" style={{ color: "#d4adf5", fontSize: "18px", cursor: "pointer", marginLeft: "6px" }} onClick={() => changeInjectionLicenseStatus(row._id, row.associate_license_status !== 'VERIFIED')}></i>
                                      </Whisper>
                                      <button
                                        className={`badge badge-pill ${statusNewBadgeMap[row?.associate_license_status] || "badge-danger-light"}`}
                                        style={{ border: "none", cursor: "pointer" }}
                                        onClick={() => changeInjectionLicenseStatus(row._id, row.associate_license_status !== 'VERIFIED')}
                                      >
                                        {row?.associate_license_status === 'VERIFIED' ? t('VERIFIED') : t('NOT VERIFIED')}
                                      </button>
                                    </div>
                                  </td>



                                  <td>
                                    {row?.associate_preferred_services?.some(s =>
                                      s.subcategorydata?.some(sub => sub.massage_license_required === true)
                                    ) ? (
                                      <span className="badge badge-pill badge-info-light">Registered</span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning-light">Not Registered</span>
                                    )}
                                  </td>

                                  <td>
                                    {row.hasInjectionConcierge ? (
                                      <span className="badge badge-pill badge-info-light">Registered</span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning-light">Not Registered</span>
                                    )}
                                  </td>

                                  {/* <td>
                                    {row?.createdAt
                                      ? formateDateWithMonth(row.createdAt)
                                      : "N/A"}
                                  </td> */}

                                  <td>{row?.createdAt ? formatDateWithTime(row.createdAt) : "N/A"}</td>

                                  {(can("/admin/babe-associate/view") || can("/admin/babe-associate/edit") || can("/admin/babe-associate/delete")) && (
                                    <td>
                                      <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                        <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                          {can("/admin/babe-associate/view") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                              <button
                                                type="button"
                                                className="btn view"
                                                onClick={() => {
                                                  viewfunction(row);
                                                }}
                                              >
                                                <i className="ri-eye-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}
                                          {can("/admin/babe-associate/edit") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Edit</Tooltip>}>
                                              <button
                                                type="button"
                                                className="btn edit"
                                                onClick={() => {
                                                  goToEdit(row);
                                                }}
                                              >
                                                <i className="ri-pencil-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}
                                          {can("/admin/babe-associate/delete") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Delete</Tooltip>}>
                                              <button
                                                type="button"
                                                className="btn delete"
                                                onClick={() => {
                                                  Deletefunction(row);
                                                }}
                                              >
                                                <i className="ri-delete-bin-6-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={14} className="text-center">
                                {t("msg_no_records")}
                              </td>
                            </tr>
                          )}
                        </>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className=""
                    id="example1_info"
                    role="status"
                    aria-live="polite"
                  >
                    <b>
                      {t("msg_total_records")} : {datalength ? datalength : "0"}
                    </b>
                  </div>
                  {datalength && datalength > 0 ? (
                    <CustomPagination
                      datalength={datalength}
                      itemperpage={itemperpage}
                      currentPage={page}
                      setPage={setPage}
                      pageRoute={[
                        {
                          name: "Reataurant",
                          path: "/admin/babe-associate/list",
                        },
                      ]}
                    />
                  ) : (
                    ""
                  )}
                </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default BabeAssociateTable;
